export interface AppError {
  title: string;
  status: string;
  detail: string;
  type: string;
  /**
   * RFC 9457 extension members — the backend nests them under `extensions`
   * (its logging middleware depends on that shape) rather than spreading
   * them top-level. Optional and per-error; isAppError deliberately does not
   * require it.
   */
  extensions?: {
    /** 409 Account.OwnedGroupsExist: the blocking groups, with ids. */
    ownedGroups?: { id: string; name: string }[];
  };
}
export function isAppError(obj: object): obj is AppError {
  return (
    obj &&
    typeof obj === "object" &&
    "title" in obj &&
    "status" in obj &&
    "detail" in obj &&
    "type" in obj
  );
}
export class ApiError<T = unknown> extends Error {
  public data?: T;
  public status?: number;

  constructor(message: string, data?: T, status?: number) {
    super(message);
    this.name = "ApiError";
    this.data = data;
    this.status = status;
  }
}
